"use client";

import React from "react";
import { Globe, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DataSharing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="data-sharing" className="relative w-full bg-background py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(var(--color-border)_1px,transparent_1px)] [background-size:24px_24px] opacity-30" />
      
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-ring/5 rounded-full blur-3xl -translate-y-1/2" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl translate-y-1/2" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="relative bg-background/40 backdrop-blur-md border border-border/60 rounded-2xl p-8 md:p-14 shadow-xl">
            
            {}
            <div className="absolute -top-5 -left-5 md:-top-6 md:-left-6 bg-card p-3 md:p-4 rounded-xl shadow-md border border-border/50 text-ring flex items-center justify-center">
              <Globe className="size-6 md:size-8" strokeWidth={1.5} />
            </div>

            {}
            <div className="absolute -bottom-5 -right-5 md:-bottom-6 md:-right-6 bg-card p-3 md:p-4 rounded-xl shadow-md border border-border/50 text-ring flex items-center justify-center">
              <ShieldCheck className="size-6 md:size-8" strokeWidth={1.5} />
            </div>

            <div className="flex flex-col md:flex-row gap-6 md:gap-10">
              {}
              <div className="hidden md:block w-[2px] shrink-0 bg-ring rounded-full opacity-80" />
              
              {}
              <div className="md:hidden h-[2px] w-16 bg-ring rounded-full opacity-80 mb-2" />

              {}
              <div className="space-y-6">
                <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground font-serif">
                  Personal Contact Information Sharing
                </h2>
                <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
                  We implement rigorous security measures to safeguard your personal contact information. Utilizing advanced encryption protocols, we ensure that contact data shared for service facilitation remains strictly confidential and protected from unauthorized access at all times.
                </p>
                <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-sans">
                  Our information management systems are designed with a primary focus on individual privacy. We maintain high standards of data protection and comply with global privacy regulations, ensuring your personal contact details are handled with the utmost integrity and discretion.
                </p>
                <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-sans">
                  Personal data may be shared only with trusted maritime suppliers, agents or service providers when necessary to process the RFQ or coordinate the requested service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}